<template lang="html">
  <v-list-tile to='/messages' :class="{'non-clickable': !User.hasPermission('messages')}">
    <v-list-tile-avatar>
      <h-icon>message</h-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <div class="message-tile">
        <span>Messages </span>
        <span class="unread-messages" v-if="unreadMessages">{{unreadMessages}}</span>
      </div>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
import axios from "axios";
import roomsSeenHub from "@/services/hubs/roomsSeen";
import moment from "moment";
import messagingChannel from "@/services/messaging/channelManagement";
import User from "@/services/api/authUser";
import snackbarHub from "@/services/hubs/snackbar";

export default {
  data() {
    return {
      missedConvos: {},
      User
    };
  },
  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}coaches/messaging-rooms/info/`)
      .then(({ data }) => {
        this.missedConvos = {};
        for (const [id, count] of Object.entries(data)) {
          this.missedConvos[id] = { count, last_seen: moment() };
        }
      });

    roomsSeenHub.registerListener(roomId => {
      this.missedConvos[roomId] = {
        count: 0,
        last_seen: moment()
      };
      // forces vue to update its watch
      this.missedConvos = Object.assign({}, this.missedConvos);
    });
    this.channel = messagingChannel.getChannel(User.id, "user");
    this.channel.messages.subscribe(msg => {
      let room = this.missedConvos[msg.room_id];
      if (msg.sender_id == User.id) {
        this.missedConvos[msg.room_id] = {
          last_seen: moment(msg.created_at),
          count: 0
        };
      } else if (!room) {
        this.missedConvos[msg.room_id] = {
          count: 1,
          last_seen: moment()
        };
      } else if (room.last_seen < moment(msg.created_at)) {
        this.missedConvos[msg.room_id] = {
          count: room.count + 1,
          last_seen: room.last_seen
        };
        snackbarHub.update("You have a new message");
        this.missedConvos = Object.assign({}, this.missedConvos);
      }
    });
  },
  computed: {
    unreadMessages() {
      return Object.keys(this.missedConvos).reduce(
        (sum, id) => sum + this.missedConvos[id]["count"],
        0
      );
    }
  }
};
</script>

<style lang="less">
.message-tile {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
}
.unread-messages {
  border-width: 1px;
  // border-color: red;
  border-style: solid;
  margin-left: 10px;
  padding: 1px 5px;
  border-radius: 35%;
  background-color: red;
  border-color: red;
  color: white;
  font-weight: 800;
}
</style>
